
const bodyTypes = [
    '14', '40', '41'
];

const CCCPrivatePassengerclasscodes = [
    "7381", "7382", "7383", "7386", "7387", "7388", "7391", "7392", "7393", "7394", "7398", "7399"
];

const cccLightVehPrimaryClassCodes = [
    "011", "012", "013", "014", "015", "016", "021", "022", "023", "024", "025", "026", "031", "032", "033", "034", "035", "036"
];

const cccLightVehSecondaryClassCodes = [
    "31", "32", "33", "34", "35", "39", "61", "62", "69", "81", "82", "83", "84", "85", "89", "99"
];

const cccMedVehPrimaryClassCodes = [
    "211", "212", "213", "214", "215", "216", "221", "222", "223", "224", "225", "226", "231", "232", "233", "234", "235", "236"
];

const cccMedVehSecondaryClassCodes = [
    "31", "32", "33", "34", "35", "39", "61", "62", "69", "81", "82", "83", "84", "85", "89", "99"
];

export {
    bodyTypes,
    CCCPrivatePassengerclasscodes,
    cccLightVehPrimaryClassCodes,
    cccLightVehSecondaryClassCodes,
    cccMedVehPrimaryClassCodes,
    cccMedVehSecondaryClassCodes

} 


     
     
     
     
